import * as localStorageProvider from './local-storage.service';

export const useLocalStorage = <T>(
  key: string,
): [() => T | null, (data: T) => void] => {
  const getValue = () => localStorageProvider.getValue<T>(key);

  const setValue = (data: T) => {
    localStorageProvider.setValue(key, data);
  };

  return [getValue, setValue];
};
